export default __webpack_public_path__ + "static/media/purple-squares.33c9b31f.svg";